export function createQueryString(params) {
	return Object.keys(params)
		.map(k => {
			if (Array.isArray(params[k])) return params[k].map(x => encodeURIComponent(k) + '=' + encodeURIComponent(x)).join('&');
			return encodeURIComponent(k) + '=' + encodeURIComponent(params[k]);
		})
		.join('&');
}

export function createUri(base, endPoint, { params = null, query = null } = {}) {
	if (params && typeof params === 'object') {
		for (let key in params) {
			endPoint = endPoint.replace(`:${key}`, params[key]);
		}
	}

	let url = `${base}/${endPoint}`;

	if (query && typeof query === 'object') {
		url += '?' + createQueryString(query);
	}

	return url;
}
